import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerResultAllExternalUrlsByHostGet = {
    path: "/scanner/result/externals/:type/:identifier",
    method: RouteHttpVerb.GET,
    obfuscatePath: "full"
};
export { locationRestScannerResultAllExternalUrlsByHostGet };
